import React from 'react'
import { Column, Columns, Container } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import { getText } from '../../../internal/TextLabels'
import { Countries } from '../../../models/countries'
import styles from '../shared/transactions.style'
import { FormattedAmount } from '../shared/transaction-utils'
import AddressInfo from './AddressInfo'
import ContactInfo from './ContactInfo'

const defaultEmptyInfoBox = (label, value, ...additionalStyles) => (
  <div style={Object.assign({}, styles.info, ...additionalStyles)}>
    <div style={styles.label}>{`${getText(label)}: `}</div>
    <div style={styles.value}>{value || '\u00A0'}</div>
  </div>
)

class TransactionOrderInfo extends React.PureComponent {
  render() {
    return this.props.transactionDetails ? (
      <Container>
        <Columns>
          <div style={styles.infobox}>
            <Column col6 noPadding>
              <Container>
                <Columns>
                  <Column col6 noPadding>
                    {defaultEmptyInfoBox(
                      'transactions.transaction.orderDetails.accountNumber',
                      this.props.transactionDetails.account &&
                        this.props.transactionDetails.account.accountNumber,
                    )}
                  </Column>

                  <Column col3 noPadding>
                    {defaultEmptyInfoBox(
                      'transactions.transaction.orderDetails.customerType',
                      this.props.transactionDetails.paymentMethod &&
                        this.props.transactionDetails.paymentMethod
                          .customerType &&
                        getText(
                          `transactions.transaction.orderDetails.customerTypeValue.${this.props.transactionDetails.paymentMethod.customerType}`,
                        ),
                      styles.noPaddingLeft,
                    )}
                  </Column>
                  <Column col3 noPadding>
                    {defaultEmptyInfoBox(
                      'transactions.transaction.orderDetails.channelType',
                      this.props.transactionDetails.channelType &&
                        getText(
                          `transactions.transaction.orderDetails.channelTypeValue.${this.props.transactionDetails.channelType}`,
                        ),
                      styles.noPaddingLeft,
                    )}
                  </Column>
                </Columns>
              </Container>
            </Column>
            <Column col2 noPadding>
              {defaultEmptyInfoBox(
                'transactions.transaction.orderDetails.paymentMethod',
                this.props.transactionDetails.paymentMethod &&
                  this.props.transactionDetails.paymentMethod.provider &&
                  this.props.transactionDetails.paymentMethod.provider.toLowerCase() !==
                    'resurs'
                  ? this.props.transactionDetails.paymentMethod.provider
                  : this.props.transactionDetails.paymentMethod?.description,
                styles.noPaddingLeft,
              )}
            </Column>
            <Column col2 noPadding>
              {defaultEmptyInfoBox(
                'transactions.transaction.orderDetails.sum',
                this.props.transactionDetails.payment &&
                  this.props.transactionDetails.payment.paymentStatus &&
                  FormattedAmount(
                    this.props.transactionDetails.payment.paymentStatus
                      .orderAmount,
                  ),
                styles.noPaddingLeft,
              )}
            </Column>
            <Column col2 noPadding>
              {defaultEmptyInfoBox(
                'transactions.transaction.orderDetails.requestedExtra',
                this.props.transactionDetails.application &&
                  this.props.transactionDetails.payment &&
                  this.props.transactionDetails.payment.paymentStatus &&
                  FormattedAmount(
                    this.props.transactionDetails.application.approvedAmount -
                      this.props.transactionDetails.payment.paymentStatus
                        .orderAmount,
                  ),
                styles.noPaddingLeft,
              )}
            </Column>
          </div>
        </Columns>
        <Columns>
          <div style={styles.infobox}>
            <Column col4 noPadding>
              {defaultEmptyInfoBox(
                'transactions.transaction.orderDetails.billingAddress',
                <AddressInfo
                  address={
                    this.props.transactionDetails.store.country !== Countries.NO
                      ? this.props.transactionDetails.customer.billingAddress ||
                        this.props.transactionDetails.customer
                          .customerGivenAddress
                      : this.props.transactionDetails.customer
                          .customerGivenAddress
                  }
                  customer={this.props.transactionDetails.customer}
                />,
                styles.noBorderBottom,
                styles.noPaddingLeft,
                styles.borderLeft,
              )}
            </Column>
            <Column col4 noPadding>
              {defaultEmptyInfoBox(
                'transactions.transaction.orderDetails.deliveryAddress',
                <AddressInfo
                  address={
                    this.props.transactionDetails.customer
                      .customerGivenDeliveryAddress
                  }
                />,
                styles.noBorderBottom,
                styles.noPaddingLeft,
                styles.borderLeft,
              )}
            </Column>
            <Column col4 noPadding>
              {defaultEmptyInfoBox(
                'transactions.transaction.orderDetails.contactInfo',
                <ContactInfo
                  customer={this.props.transactionDetails.customer}
                />,
                styles.noBorderBottom,
                styles.noPaddingLeft,
                styles.borderLeft,
              )}
            </Column>
          </div>
        </Columns>
      </Container>
    ) : (
      <div>
        {this.props.transaction && (
          <div style={styles.infobox}>
            {defaultEmptyInfoBox(
              'transactions.transaction.orderDetails.accountNumber',
              this.props.transaction && this.props.transaction.accountNumber,
            )}
            {defaultEmptyInfoBox(
              'transactions.transaction.orderDetails.channelType',
              getText(
                'transactions.transaction.orderDetails.terminalTransactionChannel',
              ),
            )}
            {defaultEmptyInfoBox(
              'transactions.transaction.orderDetails.sum',
              FormattedAmount(this.props.transaction.amount),
              styles.noBorder,
            )}
          </div>
        )}
      </div>
    )
  }
}

TransactionOrderInfo.propTypes = {
  transactionDetails: PropTypes.object,
  transaction: PropTypes.object,
}

TransactionOrderInfo.defaultProps = {
  transactionDetails: null,
  transaction: null,
}

export default TransactionOrderInfo
